import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-recently",
  "use": "icon-recently-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-recently\">\n<style type=\"text/css\">\n\t#icon-recently .st0{fill:#333333;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M24,2C11.9,2,2,11.9,2,24s9.9,22,22,22s22-9.9,22-22S36.1,2,24,2z M24,43C13.5,43,5,34.5,5,24S13.5,5,24,5\n\t\ts19,8.5,19,19S34.5,43,24,43z\" />\n\t<path class=\"st0\" d=\"M33.5,23h-8V11.5c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v13c0,0.8,0.7,1.5,1.5,1.5c0.1,0,0.2,0,0.3,0\n\t\tc0.1,0,0.2,0,0.3,0h9c0.8,0,1.5-0.7,1.5-1.5S34.3,23,33.5,23z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcons/svg/recently.svg
// module id = NIcp
// module chunks = 35